export const categoryField = /* GraphQL */ `
    fragment CategoryFields on CategoryTreeItem {
        name
        path
        entityId
        description
    }
`
